import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { onboardingApi } from '../../../api/recruiting.js';
import { hrApi } from '../../../api/hr.js';

export default function Journeys() {
  const [items, setItems] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState(null);

  function refresh() {
    setLoading(true);
    onboardingApi
      .listJourneys()
      .then((d) => setItems(d?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(() => {
    refresh();
    hrApi.listEmployees().then((d) => setEmployees(d?.items || [])).catch(() => {});
    onboardingApi.listTemplates().then((d) => setTemplates(d?.items || [])).catch(() => {});
  }, []);

  async function startJourney(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    try {
      await onboardingApi.startJourney({
        employeeId: fd.get('employeeId'),
        templateId: fd.get('templateId') || null,
      });
      form.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to start journey');
    }
  }

  return (
    <section data-testid="onboarding-journeys-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div><h1>Onboarding Journeys</h1><p className="muted">{items.length} journeys</p></div>
        <button className="btn primary" data-testid="onboarding-journey-start" onClick={() => setShowForm((s) => !s)}>
          {showForm ? 'Close' : '+ Start Journey'}
        </button>
      </header>
      {error && <div className="alert error">{error}</div>}

      {showForm && (
        <form onSubmit={startJourney} className="card form-card grid-form">
          <label>Employee
            <select name="employeeId" data-testid="onboarding-journey-employee-select" required>
              <option value="">—</option>
              {employees.map((e) => <option key={e.id} value={e.id}>{e.user_name || e.employee_code}</option>)}
            </select>
          </label>
          <label>Template
            <select name="templateId" data-testid="onboarding-journey-template-select">
              <option value="">— none —</option>
              {templates.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
            </select>
          </label>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="onboarding-journey-start-submit">Start</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="onboarding-journey-list">
          <thead><tr><th>Employee</th><th>Template</th><th>Status</th><th>Due</th></tr></thead>
          <tbody>
            {items.map((j) => (
              <tr key={j.id} data-testid={`onboarding-journey-row-${j.id}`}>
                <td><Link to={`/recruiting/onboarding/${j.id}`} data-testid={`onboarding-journey-link-${j.id}`}>{j.employee_name || j.employee_code || j.id}</Link></td>
                <td>{j.template_name || '—'}</td>
                <td><span className={`chip status-${j.status}`}>{j.status}</span></td>
                <td>{j.due_at ? String(j.due_at).slice(0, 10) : '—'}</td>
              </tr>
            ))}
            {!loading && items.length === 0 && <tr><td colSpan={4} className="muted">No journeys yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
